import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

const ALIGN_ITEMS = { center: 'center', left: 'flex-start', right: 'flex-end' }

/**
 * Shows a small caption row above a value, such as "W x H x L" above "100 x 50 x 3000 mm", so a
 * reader can tell which number is which while the value keeps its plain form.
 * @param {Object} props
 * @param {string} [props.caption] - The caption text; nothing extra renders when it is empty
 * @param {'left'|'center'|'right'} [props.align] - Horizontal alignment of both rows
 * @param {import('react').ReactNode} props.children - The value
 * @returns {JSX.Element}
 */
const CaptionedValue = ({ align = 'left', caption, children }) => {
    if (!caption) return children

    return (
        <Box sx={{ alignItems: ALIGN_ITEMS[align], display: 'flex', flexDirection: 'column' }}>
            <Typography
                sx={{ color: 'text.secondary', fontSize: '0.6875rem', lineHeight: 1.3, textTransform: 'none' }}
                variant="overline"
            >
                {caption}
            </Typography>
            {children}
        </Box>
    )
}

CaptionedValue.propTypes = {
    align: PropTypes.oneOf(['center', 'left', 'right']),
    caption: PropTypes.string,
    children: PropTypes.node,
}

export default CaptionedValue
